import rotasAPI from "@/router/rotasAPI";
import Echo from 'laravel-echo';

export default {
    retornaAtributoArray(array, campo) {
        return array.map(function(item) {
            return item[campo];
        });
    },

    verificaCPNJMatriz(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, "");
        if (cnpj == "") return false;
        if (cnpj == null) return false;
        if (cnpj.length != 14) return false;
        return cnpj.substr(11, 1) == "1" ? true : false;
    },

    validarCNPJ(doc) {
        if (!doc) return false

        if (/[^A-Z\d./-]/i.test(doc)) return false

        doc = doc.replaceAll(/[./-]/g, '').toUpperCase()

        if (!/^[A-Z\d]{12}\d{2}$/.test(doc)) return false

        if (doc === '00000000000000') return false

        const TAMANHO_SEM_DV = 12
        const VALOR_BASE = '0'.codePointAt(0)
        const PESOS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

        const valores = []
        for (let i = 0; i < TAMANHO_SEM_DV; i++) {
            valores.push(doc.codePointAt(i) - VALOR_BASE)
        }

        let somaDV1 = 0
        for (let i = 0; i < TAMANHO_SEM_DV; i++) {
            somaDV1 += valores[i] * PESOS[i + 1]
        }
        const dv1 = somaDV1 % 11 < 2 ? 0 : 11 - (somaDV1 % 11)

        let somaDV2 = 0
        for (let i = 0; i < TAMANHO_SEM_DV; i++) {
            somaDV2 += valores[i] * PESOS[i]
        }
        somaDV2 += dv1 * PESOS[TAMANHO_SEM_DV]
        const dv2 = somaDV2 % 11 < 2 ? 0 : 11 - (somaDV2 % 11)

        const dvInformado = doc.substring(TAMANHO_SEM_DV)
        return dvInformado === `${dv1}${dv2}`
    },

    validarCPF(cpf) {
        cpf = this.strClear(cpf)
        if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
        var result = true;
        [9, 10].forEach(function(j) {
            var soma = 0,
                r;
            cpf
                .split(/(?=)/)
                .splice(0, j)
                .forEach(function(e, i) {
                    soma += parseInt(e) * (j + 2 - (i + 1));
                });
            r = soma % 11;
            r = r < 2 ? 0 : 11 - r;
            if (r != cpf.substring(j, j + 1)) result = false;
        });
        return result;
    },

    preparaRotaComParametros(rota, substituir, parametro) {
        return rota.replace(substituir, parametro);
    },

    preparaRotaComMultiplosParametros(rota, valores = []) {
        for (var key in valores) {
            rota = this.preparaRotaComParametros(rota, key, valores[key]);
        }
        return rota;
    },

    retornaStringConcatenadaDeUmArrayMultiNivel(
        arrayMultiNivel,
        campo = "descricao",
        textoDefault = "Não informado"
    ) {
        var string = "";
        if (arrayMultiNivel.length > 0) {
            string = arrayMultiNivel
                .map(function(item) {
                    return item[campo];
                })
                .join(", ");
        }

        return string ? string : textoDefault;
    },

    variavelExiste(variavel) {
        return typeof variavel != "undefined";
    },

    urlSite(path = "") {
        return process.env.VUE_APP_APP_URL + path;
    },

    baixarArquivo(blob, filename) {
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                var url = URL.createObjectURL(blob),
                    idUnico = new Date()
                    .toISOString()
                    .replaceAll(":", "-")
                    .replaceAll(".", "-"),
                    novoNomeArquivo = idUnico + "_" + filename;

                link.setAttribute("href", url);
                link.setAttribute("download", novoNomeArquivo);
                link.style.visibility = "hidden";

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },

    baixarArquivoCsv(conteudo, filename) {
        var blob = new Blob([conteudo], {
            type: "text/csv;charset=utf-8;",
        });
        this.baixarArquivo(blob, filename);
    },

    formataCnpj(cnpj) {
        if (!cnpj) return ''
        const limpo = String(cnpj).replaceAll(/[./-]/g, '').toUpperCase()
        if (limpo.length !== 14) return cnpj
        return `${limpo.slice(0,2)}.${limpo.slice(2,5)}.${limpo.slice(5,8)}/${limpo.slice(8,12)}-${limpo.slice(12,14)}`
    },

    converteDataBancoParaHumano(data, truncarAno = false) {
        let dataTrun = data.slice(0, 10),
            ano = dataTrun.split("-")[0],
            mes = dataTrun.split("-")[1],
            dia = dataTrun.split("-")[2];

        if (truncarAno) {
            ano = ano.substr(-2);
        }

        return `${dia}/${mes}/${ano}`;
    },

    converteHoraBancoParaHumano(hora) {
        return hora.substr(0, 8);
    },

    converteDateTimeBancoParaHumano(datetime) {
        let data = this.converteDataBancoParaHumano((datetime.split(" ")[0])),
            hora = this.converteHoraBancoParaHumano((datetime.split(" ")[1]));
        return `${data} ${hora}`;
    },

    removeAcentos(valor) {
        return valor.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    validarEmail(email) {
        let re = /\S+@\S+\.\S+/;

        return re.test(email);
    },

    handlePluck(arr, element) {
        let newArr = [];

        arr.forEach((obj, _i) => {
            newArr.push(obj[element]);
        });

        return newArr;
    },

    handleConcatNoRepeat(arr1, arr2) {
        let r1 = arr1;
        let r2 = arr2;

        let onlyR1 = r1.filter(function(element) {
            if (r2.indexOf(element) === -1)
                return element;
        });

        let onlyR2 = r2.filter(function(element) {
            if (r1.indexOf(element) === -1)
                return element;
        });

        return onlyR1.concat(onlyR2);
    },

    PusherAuth(token) {
        window.Pusher = require('pusher-js');
        var RotaBroadcastingAuth = process.env.VUE_APP_API_URL + rotasAPI.BroadcastingAuth;
        window.Echo = new Echo({
            authEndpoint: RotaBroadcastingAuth,
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_APP_KEY,
            cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
            encrypted: true,
            auth: {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            },
        });
    },

    strClear(str) {
        return str.replace(/\D/g, '')
    },

    converteArrayAggParaString(array_agg) {
        array_agg = array_agg.replaceAll("{", "");
        array_agg = array_agg.replaceAll("}", "");
        array_agg = array_agg.replaceAll(",NULL", "");
        array_agg = array_agg.replaceAll("NULL", "");
        array_agg = array_agg.replaceAll(",", ", ");
        array_agg = array_agg.replaceAll('"', "");
        return array_agg;
    },

    converteArrayAggParaArray(array_agg) {
        return this.converteArrayAggParaString(array_agg).split(', ');

    },
    delay(ms = 1000) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    findIndexInArray(array, objeto, campo) {
        return array.findIndex(x => x[campo] === objeto[campo]);
    },

    encontrarValorMaisAltaEmArray(array, propriedade) {
      let valorMaisAlto = array[0][propriedade];

      for (const element of array) {
        if (element[propriedade] > valorMaisAlto) {
          valorMaisAlto = element[propriedade];
        }
      }

      return valorMaisAlto;
    },

    removeHTMLTags(str) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = str;
      return tmp.innerText;
    },

    truncateText(text, maxLength) {
      return text.length > maxLength ? text.slice(0, maxLength - 3) + '...' : text;
    },

    removeAcentosString(valor) {
      return valor.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    retornaRoutePathPorModulo(moduleKey, childRoute) {
      return this.removeAcentosString(
        ('/' + moduleKey + childRoute).replace(/ /g, '-').replace(/_/g, '-').toLowerCase()
      );
    },

    retornaRouteNamePorModulo(moduleKey, childKeyTitle) {
      return this.removeAcentosString(
        (moduleKey + '-' + childKeyTitle).replace(/_/g, '-').toLowerCase()
      );
    },

    retornaRouteRulePorModulo(moduleKey, childKeyTitle) {
      return this.removeAcentosString(
        (
          'MODULO_' + moduleKey + '_'
          + childKeyTitle
        ).toUpperCase()
      );
    }
}
